"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeAutocompleteStyles = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var makeAutocompleteStyles = function makeAutocompleteStyles(_ref) {
  var primitives = _ref.primitives,
      tokens = _ref.tokens;
  return {
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '&[class*="DhigCombobox"]': {
            '&[class*="MuiAutocomplete-hasPopupIcon"]': {
              '& [class*="MuiAutocomplete-inputRoot"]': {
                paddingRight: primitives.spacings["3"]
              }
            },
            '& [class*="DhigCombobox--textField"]': {
              '& [class*="DhigCombobox--input"][class*="MuiInputBase-inputAdornedEnd"]': {
                padding: "".concat(primitives.spacings["2"], " ").concat(primitives.spacings["3"])
              }
            }
          },
          '& [class*="DhigCombobox--textField"]': {
            '& [class*="MuiInput-root"]': {
              display: "flex",
              flexWrap: "wrap",
              paddingRight: primitives.spacings["0"]
            },
            '& [class*="MuiAutocomplete-endAdornment"]': {
              display: "flex",
              flexDirection: "row",
              marginRight: "0",
              top: primitives.spacings["2"],
              right: primitives.spacings["2"],
              minWidth: "fit-content",
              gap: primitives.spacings["1"],
              "& button": {
                color: tokens.colors["ink-on-background"].rgb
              }
            }
          },
          '& [class*="DhigCombobox--input"]': {},
          '&[class*="DhigCombobox--multiple"]': {
            '& [class*="DhigCombobox--textField"]': {
              '& [class*="MuiInput-root"]': {
                paddingLeft: primitives.spacings["3"],
                paddingBottom: primitives.spacings["2"],
                '& [class*="MuiChip-root"]': {
                  margin: "".concat(primitives.spacings["2"], " 2px ").concat(primitives.spacings["0"])
                }
              }
            }
          },
          '&[class*="DhigCombobox--layout--grow"]': {
            '& [class*="DhigCombobox--textField"]': {
              maxHeight: "212px",
              '& [class*="MuiInput-root"]': {
                // highly specific to override input styles, see issue #717
                '&[class*="MuiInputBase-root"]': {
                  "&.Mui-focused:not(.Mui-disabled):before": {
                    boxShadow: "none"
                  }
                },
                overflow: "auto",
                paddingRight: "46px",
                "&::before": {
                  borderBottom: "none"
                },
                "&::after": {
                  borderBottom: "none"
                },
                "&:hover": {
                  "&::before": {
                    boxShadow: "none"
                  }
                },
                '& [class*="DhigCombobox--input"]': {
                  flexBasis: "content",
                  padding: primitives.spacings["0"],
                  margin: "".concat(primitives.spacings["2"], " 2px ").concat(primitives.spacings["0"])
                }
              }
            }
          },
          '&[class*="DhigCombobox--layout--fixed"]': {
            '& [class*="DhigCombobox--textField"]': {
              '& [class*="MuiInput-root"]': {
                flexWrap: "nowrap",
                paddingTop: primitives.spacings["2"],
                '& [class*="MuiChip-root"]': {
                  marginTop: primitives.spacings["0"]
                },
                '& [class*="DhigCombobox--input"]': {
                  padding: primitives.spacings["0"],
                  marginLeft: primitives.spacings["1"]
                }
              }
            }
          },
          '&[class*="DhigSearch"]': {},
          '& [class*="DhigSearch--textField"]': {
            backgroundColor: tokens.colors["search-field-fill"].rgb,
            borderRadius: primitives.spacings[1],
            height: "40px",
            '& [class*="MuiAutocomplete-inputRoot"]': _objectSpread(_objectSpread({
              borderRadius: primitives.spacings[1],
              border: "".concat(primitives.borderWidths.medium, " solid ").concat(primitives.colors.detail.transparent),
              boxShadow: "none",
              flexWrap: "nowrap",
              height: "100%"
            }, tokens.transitions["state-blur"]), {}, {
              "&.Mui-focused": _objectSpread({
                border: "1px solid ".concat(primitives.colors.accent.iris)
              }, tokens.transitions["state-activate"]),
              "&.Mui-disabled": {
                '& [class*="MuiInputAdornment-root"]': {
                  opacity: tokens.opacities.disabled.opacity
                },
                pointerEvents: "none",
                color: tokens.colors["ink-on-background"].rgb
              },
              "&:focus, &:focus:active": _objectSpread({
                border: "".concat(primitives.borderWidths.large, " solid ").concat(primitives.colors.accent.iris)
              }, tokens.transitions["state-activate"]),
              "&:active": _objectSpread({
                border: "".concat(primitives.borderWidths.medium, " solid ").concat(primitives.colors.accent.iris)
              }, tokens.transitions["state-activate"]),
              "&:hover, &.Mui-focused:not(:hover)": _objectSpread(_objectSpread({
                backgroundColor: tokens.colors["hover-fill-subtle"].rgb
              }, tokens.transitions["state-activate"]), {}, {
                '&[class*="MuiInput-root"]': {
                  boxShadow: "none"
                }
              }),
              '& [class*="MuiInputAdornment-root"]': {
                width: "unset",
                paddingLeft: primitives.spacings["2"],
                paddingRight: primitives.spacings["0"],
                marginRight: primitives.spacings["0"],
                '& [class*="MuiSvgIcon-root"]': {
                  height: "24px",
                  width: "unset"
                }
              }
            }),
            '& [class*="DhigSearch--input"]': {
              padding: primitives.spacings["1"]
            },
            '& [class*="MuiAutocomplete-endAdornment"]': {
              top: "unset",
              marginRight: primitives.spacings["2"]
            }
          },
          '& [class*="DhigSearch--input"]': {},
          '& [class*="MuiTextField-root"]': {
            minHeight: "40px",
            '& [class*="MuiInput-root"]': {
              paddingBottom: primitives.spacings["0"],
              color: tokens.colors["ink-on-background"].rgb,
              '& [class*="MuiAutocomplete-endAdornment"]': _objectSpread(_objectSpread({
                height: primitives.spacings["6"],
                width: primitives.spacings["6"]
              }, tokens.transitions["state-blur"]), {}, {
                '& [class*="MuiAutocomplete-clearIndicator"]': {
                  visibility: "unset",
                  '& [class*="MuiSvgIcon-root"]': {
                    color: tokens.colors["ink-on-background"].rgb
                  },
                  "&:hover": _objectSpread({
                    backgroundColor: tokens.colors["hover-fill-subtle"].rgb
                  }, tokens.transitions["state-activate"]),
                  "&:active": _objectSpread({
                    backgroundColor: tokens.colors["pressed-fill-subtle"].rgb
                  }, tokens.transitions["state-activate"]),
                  "&:focus": {
                    outline: "none"
                  },
                  "&:focus-visible": _objectSpread(_objectSpread({
                    boxShadow: tokens.effects["focus-ring-thin"].boxShadow
                  }, tokens.transitions["state-activate"]), {}, {
                    "&:hover, &:active": {
                      backgroundColor: tokens.colors["fill-elevation-0"].rgb
                    }
                  })
                }
              })
            }
          }
        }
      }
    }
  };
};

exports.makeAutocompleteStyles = makeAutocompleteStyles;